package ui.new_ui.components.search

import ui.new_ui.color_scheme.MainColorScheme
import ui.new_ui.requirements.MinRequirements
import web.cssom.FontSize
import web.cssom.Length
import web.cssom.px

object SearchStyles: MinRequirements {

    object SearchBox{
        val marginTop = 10.px
    }
    object Shadow {
        fun shadowColor() = MainColorScheme.BackgroundColors.backgroundColorOnContainer()
        val shadowSpreadRadius = 0.px
        val shadowBlurRadius = 12.px
    }
    val fontSize = FontSize.large
    fun backgroundColor() = MainColorScheme.BackgroundColors.backgroundColorContainer()
    val innerPadding = 4.px
    val borderRadius = 10.px
    val borderColor = MainColorScheme.MainColors.mainColorContainer
    override val minHeight: Length = 40.px

}